import React from "react";
import { Box } from "@mui/material";
import CustomDateField from "./CustomDateField";
import CustomLabel from "./CustomLabel";

type DateRange = { start?: string; end?: string } | [string?, string?];

type Props = {
  value?: DateRange;
  onChange?: (value: DateRange) => void;
  startLabel?: string;
  endLabel?: string;
  placeholderStart?: string;
  placeholderEnd?: string;
  fullWidth?: boolean;
  size?: "small" | "medium";
};

const toStrings = (value?: DateRange): [string, string] => {
  if (!value) return ["", ""];
  if (Array.isArray(value)) return [value[0] ?? "", value[1] ?? ""];
  return [value.start ?? "", value.end ?? ""];
};

const DateRangePicker: React.FC<Props> = ({
  value,
  onChange,
  startLabel = "Start date",
  endLabel = "End date",
  placeholderStart,
  placeholderEnd,
  fullWidth = false,
  size = "small",
}) => {
  const [start, end] = toStrings(value);

  return (
    <Box
      sx={{
        display: "flex",
        gap: { xs: 0.5, sm: 1 },
        alignItems: "center",
        width: fullWidth ? "100%" : "auto",
        flexDirection: { xs: "column", sm: "row" },
       
      }}
    >
      <Box sx={{ flex: 1, width: { xs: "100%", sm: "auto" } }}>
        <CustomLabel
          text={startLabel}
          fontSize="0.95rem"
          sx={{
            mb: { xs: 0.25, sm: 0.5 },
            pl: 0.5,
            display: { xs: "block", sm: "block" },
          }}
        />
        <CustomDateField
          value={start}
          onChange={(v) => onChange?.({ start: v, end })}
          placeholder={placeholderStart}
          sx={{minWidth: { xs: "96%", sm: "100%" }, maxWidth: "200px" , backgroundColor: "white", }}
        />
      </Box>


      <Box sx={{ flex: 1, width: { xs: "100%", sm: "100%" } }}>
        <CustomLabel
          text={endLabel}
          fontSize="0.95rem"
          sx={{ mb: { xs: 0.25, sm: 0.5 }, pl: 0.5 }}
        />
        <CustomDateField
          value={end}
          onChange={(v) => onChange?.({ start, end: v })}
          placeholder={placeholderEnd}
          sx={{minWidth: { xs: "96%", sm: "100%" }, maxWidth: "200px" , backgroundColor: "white",}}
        />
      </Box>
    </Box>
  );
};

export default DateRangePicker;
